const STEVE_LIFELINE = {
  interests: {
    photo: {
      name: '2978650175_57a0cf6a41_o-1.jpg',
      remoteUrl:
        'https://memories-backend.dev.rollstudio.it/media/photos/0f6950df-7280-467d-a41b-acc6d98a01a0.jpg',
    },
    interests: {
      Business: 4,
      Religion: 4,
      Technology: 4,
    },
    description:
      'With some ingenious strategy, Steve Jobs and his team took about 15 years to transform Apple into thsdfsdfe most valuable company in the world. But while we are all witness to the end result, there was a lot of research and heavy thinking that went into developing that strategy',
    interestsDescriptions: {
      Music: 'Sound Hound',
      Travel: 'Wanderluster',
      Business: 'Boardroom Brainiac',
      Religion: 'Man of Faith',
      Technology: 'Techno-Junkie',
    },
  },
  remembering: {
    sex: 'm',
    photo: {
      remoteUrl:
        'https://memories-backend.dev.rollstudio.it/media/photos/d1d90fe4-509c-4ae1-92e2-86e829c80b31.jpg',
    },
    bornTown: 'San Francisco',
    lastName: 'Jobs',
    military: false,
    birthDate: '19550224',
    bornState: 'California',
    deathDate: '20111005',
    deathTown: 'Palo Alto',
    firstName: 'Steve',
    lastWords:
      'We don’t get a chance to do that many things and everyone should be really excellent. Because this is our life. Life is brief, and then you die, you know? And we’ve all chosen to do this with our lives. So it better be damn good. It better be worth it.',
    adjectives: [
      {
        color: '#FFB32C',
        label: 'Perfectionist',
      },
      {
        color: '#FFB32C',
        label: 'Determined',
      },
      {
        color: '#E4406D',
        label: 'Passionate',
      },
    ],
    deathState: 'California',
    bornCountry: 'USA',
    placesLived: [],
    deathCountry: 'USA',
    deathDetails:
      'In Palo Alto after battling pancreatic cancer for nearly a decade. He was 56 years old.',
    bornStateCode: 'CA',
    deathStateCode: 'CA',
    bornCountryCode: 'us',
    funDescriptions: [
      {
        color: '#18A0A3',
        label: 'Creative Mind',
      },
      {
        color: '#18A0A3',
        label: 'Zen Buddhist',
      },
      {
        color: '#18A0A3',
        label: 'Perfection Believer',
      },
    ],
    birthDateTopSong: {
      title: 'Paper Doll',
      artist: 'The Mills Brothers',
      spotify: {
        uri: 'spotify:track:6iv5Q44vGvpm4uhKqzcMzy',
        url: 'https://open.spotify.com/track/6iv5Q44vGvpm4uhKqzcMzy',
      },
    },
    bornPlaceGeoJSON: {
      fcl: 'P',
      lat: '37.77493',
      lng: '-122.41942',
      name: 'San Francisco',
      fcode: 'PPLA2',
      fclName: 'city, village,...',
      countryId: '6252001',
      fcodeName: 'seat of a second-order administrative division',
      geonameId: 5391959,
      adminCode1: 'CA',
      adminName1: 'California',
      population: 864816,
      adminCodes1: {
        ISO3166_2: 'CA',
      },
      countryCode: 'US',
      countryName: 'United States',
      toponymName: 'San Francisco',
    },
    deathCountryCode: 'us',
    deathPlaceGeoJSON: {
      fcl: 'P',
      lat: '37.44188',
      lng: '-122.14302',
      name: 'Palo Alto',
      fcode: 'PPL',
      fclName: 'city, village,...',
      countryId: '6252001',
      fcodeName: 'populated place',
      geonameId: 5380748,
      adminCode1: 'CA',
      adminName1: 'California',
      population: 66853,
      adminCodes1: {
        ISO3166_2: 'CA',
      },
      countryCode: 'US',
      countryName: 'United States',
      toponymName: 'Palo Alto',
    },
    personalRelationship: 'Friendsdf',
  },
  achievements: {
    achievements: [
      {
        to: '19760101',
        from: '19740101',
        text:
          "He co-founded Apple along with Steve Wozniak in the garage of Jobs' Los Altos home on Coast Drive.",
        image: {
          name: 'original-apple.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/259d9df2-78ec-4c83-bc94-d6d610353cc4.jpg',
        },
        militaryBadge: false,
      },
      {
        to: '',
        from: '19770101',
        text:
          'He delivered the first commercially successful personal computer.',
        image: {
          name: 'Steve-Jobs-computer-Apple-II-1977.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/7a4c332d-40cc-4db2-8a6c-dda95152a0a6.jpg',
        },
        militaryBadge: false,
      },
      {
        to: null,
        from: '19860101',
        text:
          'After leaving Apple, Jobs bought the computer graphics division of Lucasfilm Ltd, which he later renamed Pixar. After signing a deal with Disney it began making CGI-animated feature films and has since earned multiple awards.',
        image: {
          name: '0ad92956a1daf71d0cacd4d28dbfc547.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/48e10e78-b2ed-4404-9df4-086f52db57cd.jpg',
        },
        militaryBadge: false,
      },
      {
        to: '',
        from: '19980101',
        text:
          'Steve introduced the world to the iMac, one of the most important products in Apple history. It set the company on a new course and forever changed the way people look at computers.',
        image: {
          name:
            'wpid-article-1317907521403-0e3ff43800000578-151791_466x512.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/9517d2b2-0c05-495b-8082-76b85d81cdab.jpg',
        },
        militaryBadge: false,
      },
      {
        to: '',
        from: '20010101',
        text:
          "'With the iPod, Apple has invented a whole new category of digital music player that lets you put your entire music collection in your pocket and listen to it wherever you go,’ said Steve Jobs, Apple’s CEO. ‘With iPod, listening to music will never be the same again.’",
        image: {
          name: 'steve-jobs-ipod.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/20463dc6-4264-4309-9413-720dfaae3a30.jpg',
        },
        militaryBadge: false,
      },
      {
        to: '',
        from: '20070101',
        text:
          "Steve revolutionized the smartphone market with the iPhone. It's perhaps the one product that made Steve Jobs a household name in many parts of the world.",
        image: {
          name: 'b2e3b94f-4bfd-4334-f403-e6a420e11884.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/a6712580-1768-463d-8557-1b85a982152b.jpg',
        },
        militaryBadge: false,
      },
    ],
  },
  relationships: {
    photos: [
      {
        image: {
          name: '1984-01-01_00400.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/7c9299ea-d88c-4aaf-91aa-7d7a54e0716b.jpg',
        },
        isFav: true,
        relationshipGroup: 'Important people',
      },
      {
        image: {
          name: 'images.jpeg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/fcfa447a-6d18-461d-975e-0bc5cc463ad5.jpg',
        },
        isFav: false,
        relationshipGroup: 'Important people',
      },
      {
        image: {
          name: 'download (4).jpeg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/617a0b24-5100-4933-b2ad-9277a8743f1f.jpg',
        },
        isFav: false,
        relationshipGroup: 'Important people',
      },
      {
        image: {
          name: '5616f5409dd7cc14008c0803.jpeg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/814447ac-13d9-4542-b819-1c3fda78d285.jpg',
        },
        isFav: false,
        relationshipGroup: 'Important people',
      },
      {
        image: {
          name: '1981-01-01_00147.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/de204629-3b28-4a70-9067-baaf34f89962.jpg',
        },
        isFav: false,
        relationshipGroup: 'Friendship',
      },
      {
        image: {
          name: 'Steven-Jobs-Apple-I-Stephen-Wozniak-circuit-1976.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/c4f819b4-7394-493f-a122-36acc630dfe7.jpg',
        },
        isFav: true,
        relationshipGroup: 'Friendship',
      },
      {
        image: {
          name: 'bob-iger-1119-lede.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/cd502a46-f685-44f6-9dfb-e686b99b8bc0.jpg',
        },
        isFav: false,
        relationshipGroup: 'Friendship',
      },
      {
        image: {
          name: '1957-01-01_00002.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/60ee3266-55b6-4c6e-9ad4-bf6610c46fa6.jpg',
        },
        isFav: false,
        relationshipGroup: 'Family',
      },
      {
        image: {
          name: '78373-steve-jobs-family.jpeg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/945db526-b7b7-45cf-bb08-77fe21878ce4.jpg',
        },
        isFav: false,
        relationshipGroup: 'Family',
      },
      {
        image: {
          name: '5b7efd630ce5f592208b48a0.jpeg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/8aec1576-d2ef-4fda-958f-ae36a2999a05.jpg',
        },
        isFav: false,
        relationshipGroup: 'Family',
      },
      {
        image: {
          name: 'f4ae5f14d11f78a12a269e8aabd23a86.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/aac88353-8f72-471e-b87b-d7072035cf55.jpg',
        },
        isFav: false,
        relationshipGroup: 'Family',
      },
      {
        image: {
          name: '56d482316e97c631008ba5f6.jpeg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/1992a4b7-a973-45ec-9064-86a9e3aabe25.jpg',
        },
        isFav: true,
        relationshipGroup: 'Family',
      },
    ],
    memories: [
      {
        author: 'Andrea Jung',
        description:
          'As a CEO, you have good days and bad days, and I remember I had a bad press day. Steve was a true friend — he called me on the phone and said, “Just ignore it. It’s hard but I’ve learned to. If you don’t fail, you’re not trying. Some of the world’s biggest successes come from learning from mistakes. Keep moving forward.” He was thoughtful and caring. That’s the Steve I knew. Those little touches.',
        relationship: 'Colleague',
      },
      {
        author: 'Eddy Cue',
        description:
          'Working with him, I always felt that there was a personal connection. It wasn’t just work. And in a way, sometimes he was a brother; sometimes he was a father figure, depending on what it was. But it was a family member nonetheless. And it was somebody you didn’t want to disappoint. I’ve never felt that way about anybody else that I’ve worked with. ',
        relationship: 'Colleague',
      },
    ],
    importantRelationships: [
      {
        uuid: 'ddb58830-859a-40ba-af4c-a2a8434a8e3e',
        quote: 'We had a very beautiful and rich connection',
        story:
          'Just like anyone that you share your life with, there’s an exchange and a robustness. We had a very, very beautiful and rich connection.',
        picture: {
          name: 'Screenshot 2020-07-10 at 10.18.23.png',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/4919558b-5dbb-430f-b3cd-29f2f5e94232.jpg',
        },
        lastName: 'Powell Jobs',
        firstName: 'Laurene',
        relationship: 'Wife',
        defaultPicture: null,
        relationshipGroup: 'Family',
      },
      {
        uuid: '4e33cd6e-373e-4ba6-b0a5-9171cc35b1bc',
        firstName: 'Lisa',
        relationship: 'Daughter',
        defaultPicture: 0,
        relationshipGroup: 'Family',
      },
      {
        uuid: '7546feba-1203-467e-89a0-f788b08b907a',
        firstName: 'Eve',
        relationship: 'Daughter',
        defaultPicture: 0,
        relationshipGroup: 'Family',
      },
      {
        uuid: 'c790215b-b670-464b-9cb5-ac4966960832',
        firstName: 'Erin',
        relationship: 'Daughter',
        defaultPicture: 0,
        relationshipGroup: 'Family',
      },
      {
        uuid: '9cedad15-0a1a-4e3e-98b7-0c71647ff4ce',
        quote: 'Steve has really changed humanity forever',
        story:
          'One profound learning I took from him was that we don’t have to accept the world that we’re born into as something that is fixed and impermeable',
        picture: {
          name: 'image-20160825-6595-d1pvw4.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/3d2d0635-d143-4db4-ad33-93962088165c.jpg',
        },
        lastName: 'Wozniak',
        firstName: 'Steve',
        relationship: 'Friend',
        defaultPicture: null,
        relationshipGroup: 'Important people',
      },
      {
        uuid: 'ae662bee-3813-4690-a97b-96e287ca780e',
        quote: 'It was such nonsense, and yet he mesmerized those people',
        story:
          "Steve Jobs cast spells on everyone but he didn't fool me. Apple co-founder Steve Jobs was a one of a kind when it came to talking up new products",
        picture: {
          name: 'Bill-Gates-2011.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/cb50c8a4-d809-4cac-8d24-f4663cb23f4f.jpg',
        },
        lastName: 'Gates',
        firstName: 'Bill',
        relationship: 'Tech Giant',
        defaultPicture: null,
        relationshipGroup: 'Important people',
      },
      {
        uuid: '3b2ebc14-1e60-4fc1-b141-ec48d70266cc',
        picture: {
          name: 'John_Lasseter.JPG.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/74614d7a-2dff-42e8-a38d-7ddb5ee22a73.jpg',
        },
        lastName: 'Lasseter',
        firstName: 'John',
        relationship: 'Friend',
        defaultPicture: null,
        relationshipGroup: 'Friendship',
      },
      {
        uuid: '1e025a72-f184-4c48-a9e7-a7f257be7eb4',
        picture: {
          name: 'download (6).jpeg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/60ef325d-1079-4df6-8a75-b87e52be0930.jpg',
        },
        lastName: 'Catmull',
        firstName: 'Ed',
        relationship: 'Friend',
        defaultPicture: null,
        relationshipGroup: 'Friendship',
      },
      {
        uuid: 'aa484ad7-41f1-4a0d-af74-262b727075e4',
        picture: {
          name: 'images (1).jpeg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/3896ab9c-3a86-4ae6-a419-cf2471cbeecc.jpg',
        },
        lastName: 'Ellison',
        firstName: 'Larry',
        relationship: 'Friend',
        defaultPicture: null,
        relationshipGroup: 'Friendship',
      },
      {
        uuid: 'be0148b7-2a8d-4eb8-9bbd-1dddd4d64347',
        quote: 'He was my spiritual partner at Apple',
        picture: {
          name: 'Gear-Jony-Ive-WIRED25.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/6aca1ba9-7ce0-4619-9907-529c88072017.jpg',
        },
        lastName: 'Ive',
        firstName: 'Jony',
        relationship: 'Friend',
        defaultPicture: null,
        relationshipGroup: 'Friendship',
      },
      {
        uuid: 'db661927-25d5-4840-9a00-084fad6b7cd9',
        picture: {
          name: 'download (7).jpeg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/c2186e0d-c9f8-480a-81a2-d4bffa472c40.jpg',
        },
        lastName: 'Cook',
        firstName: 'Tim ',
        relationship: 'Friend',
        defaultPicture: null,
        relationshipGroup: 'Friendship',
      },
    ],
  },
};

const MARILYN_LIFELINE = {
  isLegacy: false,
  interests: {
    photo: {
      name: 'marilyn-reading.jpg',
      remoteUrl:
        'https://memories-backend.dev.rollstudio.it/media/photos/6c1ab70e-813f-42f9-9a25-4e46e1ff2178.jpg',
    },
    interests: {
      Food: 3,
      Sport: 2,
      Fashion: 4,
      Science: 2,
      Literature: 4,
      Socializing: 4,
      'Arts and culture': 3,
    },
    description:
      'While Marilyn Monroe has often been stigmatized as a “dumb blonde,” she was far from that. Though she did not complete her high school education, Marilyn held a lifelong quest for knowledge. Her library was reflective of that. Even in her earlier days as a studio contract player living in the Hollywood Studio Club, fellow female residents remembered Marilyn as toting her books around and that the books were one of the focal points of her room there.',
    interestsDescriptions: {
      Food: 'Manifestly Foodie',
      Sport: 'Sports superfun',
      Fashion: 'Fervent fashionista',
      Science: 'Sciencophile',
      Literature: 'Bibliomaniac',
      Socializing: 'Social butterfly',
      'Arts and culture': 'Culture vulture',
    },
  },
  remembering: {
    sex: 'f',
    photo: {
      crop: {
        top: 0,
        left: 346.8427795948928,
        width: 224.3828125,
        height: 224.3828125,
      },
      remoteUrl:
        'https://memories-backend.dev.rollstudio.it/media/photos/36a717d8-4afe-45ac-853c-861802b6c7a9.jpg',
      originalUrl:
        'blob:https://memories.dev.rollstudio.it/91b9a042-4149-4da9-9c64-52d2abd49cfa',
    },
    bornTown: 'Los Angeles',
    lastName: 'Monroe',
    military: false,
    birthDate: '19260601',
    bornState: 'California',
    deathDate: '19620805',
    deathTown: 'Brentwood',
    firstName: 'Marilyn',
    lastWords:
      "Keep smiling, because life is a beautiful thing and there's so much to smile about.",
    adjectives: [
      {
        color: '#CD36E2',
        label: 'beautiful',
      },
      {
        color: '#CD36E2',
        label: 'attractive',
      },
      {
        color: '#E4406D',
        label: 'sentimental',
      },
    ],
    deathState: 'California',
    bornCountry: 'USA',
    placesLived: [
      {
        town: 'Hollywood',
        state: 'California',
        country: 'USA',
        geojson: {
          fcl: 'P',
          lat: '34.09834',
          lng: '-118.32674',
          name: 'Hollywood',
          fcode: 'PPLX',
          fclName: 'city, village,...',
          countryId: '6252001',
          fcodeName: 'section of populated place',
          geonameId: 5357527,
          adminCode1: 'CA',
          adminName1: 'California',
          population: 167664,
          adminCodes1: {
            ISO3166_2: 'CA',
          },
          countryCode: 'US',
          countryName: 'United States',
          toponymName: 'Hollywood',
        },
        specification: 'Her acting career',
      },
      {
        town: 'New York',
        state: 'New York',
        country: 'USA',
        geojson: {
          fcl: 'P',
          lat: '40.71427',
          lng: '-74.00597',
          name: 'New York',
          fcode: 'PPL',
          fclName: 'city, village,...',
          countryId: '6252001',
          fcodeName: 'populated place',
          geonameId: 5128581,
          adminCode1: 'NY',
          adminName1: 'New York',
          population: 8175133,
          adminCodes1: {
            ISO3166_2: 'NY',
          },
          countryCode: 'US',
          countryName: 'United States',
          toponymName: 'New York City',
        },
        specification: 'Where the iconic "flying skirt" photo was captured',
      },
      {
        town: 'San Diego',
        state: 'California',
        country: 'USA',
        geojson: {
          fcl: 'P',
          lat: '32.71571',
          lng: '-117.16472',
          name: 'San Diego',
          fcode: 'PPLA2',
          fclName: 'city, village,...',
          countryId: '6252001',
          fcodeName: 'seat of a second-order administrative division',
          geonameId: 5391811,
          adminCode1: 'CA',
          adminName1: 'California',
          population: 1394928,
          adminCodes1: {
            ISO3166_2: 'CA',
          },
          countryCode: 'US',
          countryName: 'United States',
          toponymName: 'San Diego',
        },
        specification: "Where 'Some Like It Hot' was filmed",
      },
      {
        town: 'Dayton',
        state: 'Nevada',
        country: 'USA',
        geojson: {
          fcl: 'P',
          lat: '39.23714',
          lng: '-119.59295',
          name: 'Dayton',
          fcode: 'PPL',
          fclName: 'city, village,...',
          countryId: '6252001',
          fcodeName: 'populated place',
          geonameId: 5502732,
          adminCode1: 'NV',
          adminName1: 'Nevada',
          population: 8964,
          adminCodes1: {
            ISO3166_2: 'NV',
          },
          countryCode: 'US',
          countryName: 'United States',
          toponymName: 'Dayton',
        },
        specification: "Marilyn's last film",
      },
      {
        town: 'Long Island city',
        state: 'New York',
        country: 'USA',
        geojson: {
          fcl: 'P',
          lat: '40.74482',
          lng: '-73.94875',
          name: 'Long Island',
          fcode: 'PPLX',
          fclName: 'city, village,...',
          countryId: '6252001',
          fcodeName: 'section of populated place',
          geonameId: 5125125,
          adminCode1: 'NY',
          adminName1: 'New York',
          population: 25595,
          adminCodes1: {
            ISO3166_2: 'NY',
          },
          countryCode: 'US',
          countryName: 'United States',
          toponymName: 'Long Island City',
        },
        specification: 'This is some text',
      },
      {
        town: 'London',
        state: '',
        country: 'United Kingdom',
        geojson: {
          fcl: 'P',
          lat: '51.50853',
          lng: '-0.12574',
          name: 'London',
          fcode: 'PPLC',
          fclName: 'city, village,...',
          countryId: '2635167',
          fcodeName: 'capital of a political entity',
          geonameId: 2643743,
          adminCode1: 'ENG',
          adminName1: 'England',
          population: 7556900,
          adminCodes1: {
            ISO3166_2: 'ENG',
          },
          countryCode: 'GB',
          countryName: 'United Kingdom',
          toponymName: 'London',
        },
        specification: 'She performed blabla',
      },
    ],
    deathCountry: 'USA',
    deathDetails:
      'Marilyn passed away on 05 August 1962 at her home in Los Angeles at the age of just 36 — apparently by her own hand.',
    bornStateCode: 'CA',
    bornCountryCode: 'us',
    funDescriptions: ['Unforgettable icon', 'Hollywood star', 'Lasting legend'],
    birthDateTopSong: {
      title: 'Heebie Jeebies',
      artist: 'Louis Armstrong',
      spotify: {
        uri: 'spotify:track:44WgRCq0K8ZUAm70QMhFZV',
        url: 'https://open.spotify.com/track/44WgRCq0K8ZUAm70QMhFZV',
      },
    },
    bornPlaceGeoJSON: {
      fcl: 'P',
      lat: '34.05223',
      lng: '-118.24368',
      name: 'Los Angeles',
      fcode: 'PPLA2',
      fclName: 'city, village,...',
      countryId: '6252001',
      fcodeName: 'seat of a second-order administrative division',
      geonameId: 5368361,
      adminCode1: 'CA',
      adminName1: 'California',
      population: 3971883,
      adminCodes1: {
        ISO3166_2: 'CA',
      },
      countryCode: 'US',
      countryName: 'United States',
      toponymName: 'Los Angeles',
    },
    deathCountryCode: 'us',
    militaryCategory: 'Firefighter',
    deathPlaceGeoJSON: {
      fcl: 'P',
      lat: '37.93187',
      lng: '-121.69579',
      name: 'Brentwood',
      fcode: 'PPL',
      fclName: 'city, village,...',
      countryId: '6252001',
      fcodeName: 'populated place',
      geonameId: 5330642,
      adminCode1: 'CA',
      adminName1: 'California',
      population: 58968,
      adminCodes1: {
        ISO3166_2: 'CA',
      },
      countryCode: 'US',
      countryName: 'United States',
      toponymName: 'Brentwood',
    },
    personalRelationship: 'Fan',
  },
  achievements: {
    achievements: [
      {
        to: '',
        from: '19590101',
        text:
          'She starred in her best known film, ‘Some Like it Hot’ which is her most commercially successful film. The movie was listed as the greatest American comedy film of all time by the American Film Institute in 2000.',
        image: {
          name: 'unnamed (1).jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/54b18c62-b70b-402f-812b-d32efc6f8809.jpg',
        },
        militaryBadge: false,
      },
      {
        to: '',
        from: '19600101',
        text:
          "Marilyn received a Golden Globe Award for Best Actress in Comedy 'Some like it hot'.",
        image: {
          name: 'Marilyn-Monroe-Golden-Globe-Award.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/ed9f8999-861d-4034-b7bb-77ac947ee5fc.jpg',
        },
        militaryBadge: false,
      },
      {
        to: '',
        from: '19650101',
        text:
          'Marilyn Monroe’s sultry song to President John F. Kennedy in May 1962 marked one final hurrah before her life came to a sudden end less than three months later.',
        image: {
          name: 'image.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/60c393df-9307-45c0-8376-96bd046e3d10.jpg',
        },
        militaryBadge: false,
      },
      {
        to: '19620101',
        from: '19570101',
        text:
          'Marilyn was renowned for her generosity in helping others wherever she could.',
        image: {
          name: 'mmmilkfund.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/fbb710e3-294e-4b1d-8f7b-3eed4f503fa6.jpg',
        },
        militaryBadge: false,
      },
      {
        to: '19560101',
        from: '19550101',
        text:
          'Monroe moved to Manhattan and dedicated 1955 to studying acting. She took classes with Constance Collier and attended workshops on method acting at the Actors Studio, run by Lee Strasberg.',
        image: {
          name: 'AS2.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/afc94830-948a-496b-a24d-b67920715e17.jpg',
        },
        militaryBadge: false,
      },
      {
        to: '',
        from: '20190101',
        text:
          'More than half a century after she passed away, Marilyn continues to be a major popular culture icon.',
        image: {
          name: 'andy-warhol-marilyn-monroe.jpg',
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/12ba8954-c13b-4200-836f-6c9e85fbf0a6.jpg',
        },
        militaryBadge: false,
      },
    ],
  },
  relationships: {
    photos: [
      {
        image: {
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/e483ad31-9221-435f-806e-26c28ac114e4.jpg',
        },
        isFav: true,
        relationshipGroup: 'Important people',
      },
      {
        image: {
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/e001ef6c-b1ee-4a1e-8db4-0eb614d5791d.jpg',
        },
        isFav: false,
        relationshipGroup: 'Important people',
      },
      {
        image: {
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/03382584-cc95-4512-b1d6-9a019aed56c1.jpg',
        },
        isFav: false,
        relationshipGroup: 'Important people',
      },
      {
        image: {
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/79ab3ed2-bc13-4478-a908-1f7161cc783b.jpg',
        },
        isFav: false,
        relationshipGroup: 'Important people',
      },
      {
        image: {
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/17b45855-0689-4e9e-9c6c-147a50c0ab2a.jpg',
        },
        isFav: false,
        relationshipGroup: 'Important people',
      },
      {
        image: {
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/ed6943f2-3381-4465-b870-8779311886a8.jpg',
        },
        isFav: false,
        relationshipGroup: 'Important people',
      },
    ],
    memories: [
      {
        author: 'Don Murray',
        description:
          'She was a very experienced film actress, but she could forget so many of the mechanical techniques. I think it was a lack of confidence. For somebody who the camera loved, she was still terrified of going before the camera and broke out in a rash all over her body.',
        relationship: 'Friend',
      },
      {
        author: 'Mitzi Gaynor',
        description:
          'I never saw anybody work so hard. But it wasn’t an easy ride. She did such a good job and personally, I think she stole the whole damn show. I just think she was thrown into a nest of vipers.',
        relationship: 'Friend',
      },
      {
        author: 'Susan Bernard',
        description:
          "They were doing the scene with her skirt flying over the grate. They were doing the scene over and over again and Billy Wilder was getting exasperated. Suddenly, she saw my dad in the crowd. She ran up to him in front of the whole crew and gave him a big hug and said 'Remember Bernie, everything started with you'.",
        relationship: 'Friend',
      },
    ],
    importantRelationships: [
      {
        uuid: '241c00a8-fd35-4740-9f86-37bf3b87e85e',
        firstName: 'Gladys',
        relationship: 'Mother',
        defaultPicture: 0,
        relationshipGroup: 'Important people',
      },
      {
        uuid: 'aefe0b50-b384-4c5c-98da-3a11d948d32f',
        firstName: 'Charles',
        relationship: 'Father',
        defaultPicture: 0,
        relationshipGroup: 'Important people',
      },
      {
        uuid: '899e698a-3c43-40be-acf8-9485f1fca77d',
        firstName: 'Amy',
        relationship: 'Friend',
        defaultPicture: 0,
        relationshipGroup: 'Friendship',
      },
      {
        uuid: '3bf1f785-a396-41ee-bcea-302aa740c777',
        firstName: 'Joe',
        relationship: 'Partner',
        defaultPicture: 0,
        relationshipGroup: 'Important people',
      },
      {
        uuid: 'fd385355-22dd-451c-b864-ceb9c250b6c8',
        firstName: 'Anthony',
        relationship: 'Partner',
        defaultPicture: 0,
        relationshipGroup: 'Important people',
      },
      {
        uuid: 'a80b67fc-53fe-4d0d-a3a3-c37e3ac2da2b',
        firstName: 'Caroline',
        relationship: 'Daughter',
        defaultPicture: 0,
        relationshipGroup: 'Important people',
      },
      {
        uuid: '82650337-5d77-4e0e-842a-b67a6dd8e722',
        firstName: 'Tommy',
        relationship: 'Son',
        defaultPicture: 0,
        relationshipGroup: 'Important people',
      },
    ],
  },
};

const JANE_LIFELINE = {
  interests: {
    interests: {
      Travel: 4,
    },
    interestsDescriptions: {
      Travel: 'Wanderluster ',
    },
  },
  remembering: {
    sex: 'f',
    photo: {
      remoteUrl:
        'https://memories-backend.dev.rollstudio.it/media/photos/dd69fc0c-2e79-4202-a22b-ff23a9dddd9e.jpg',
    },
    bornTown: 'Rome',
    lastName: 'Robinson',
    military: false,
    birthDate: '19590101',
    deathDate: '19900404',
    deathTown: 'Paris',
    firstName: 'Jane',
    lastWords:
      'Travel more, be nice to people, and always make new friends. sdfsf',
    adjectives: [
      {
        color: '#E4406D',
        label: 'loving',
      },
      {
        color: '#F17E7E',
        label: 'friendly',
      },
      {
        color: '#003698',
        label: 'introvert',
      },
    ],
    bornCountry: 'Italy',
    placesLived: [
      {
        town: 'Lisbon',
        state: '',
        country: 'Portugal',
        geojson: {
          fcl: 'P',
          lat: '38.71667',
          lng: '-9.13333',
          name: 'Lisbon',
          fcode: 'PPLC',
          fclName: 'city, village,...',
          countryId: '2264397',
          fcodeName: 'capital of a political entity',
          geonameId: 2267057,
          adminCode1: '14',
          adminName1: 'Lisbon',
          population: 517802,
          adminCodes1: {
            ISO3166_2: '11',
          },
          countryCode: 'PT',
          countryName: 'Portugal',
          toponymName: 'Lisbon',
        },
        specification: 'Where she lived for 2 years',
      },
      {
        town: 'Montpellier',
        state: '',
        country: 'France',
        geojson: {
          fcl: 'P',
          lat: '43.61093',
          lng: '3.87635',
          name: 'Montpellier',
          fcode: 'PPLA2',
          fclName: 'city, village,...',
          countryId: '3017382',
          fcodeName: 'seat of a second-order administrative division',
          geonameId: 2992166,
          adminCode1: '76',
          adminName1: 'Occitanie',
          population: 248252,
          adminCodes1: {
            ISO3166_2: 'OCC',
          },
          countryCode: 'FR',
          countryName: 'France',
          toponymName: 'Montpellier',
        },
        specification: 'Where she found love of her life',
      },
      {
        town: 'London',
        state: '',
        country: 'Great Britain (UK)',
        geojson: {
          fcl: 'P',
          lat: '51.50853',
          lng: '-0.12574',
          name: 'London',
          fcode: 'PPLC',
          fclName: 'city, village,...',
          countryId: '2635167',
          fcodeName: 'capital of a political entity',
          geonameId: 2643743,
          adminCode1: 'ENG',
          adminName1: 'England',
          population: 7556900,
          adminCodes1: {
            ISO3166_2: 'ENG',
          },
          countryCode: 'GB',
          countryName: 'United Kingdom',
          toponymName: 'London',
        },
        specification: 'Where she studied',
      },
      {
        town: 'Warsaw',
        state: '',
        country: 'Poland',
        geojson: {
          fcl: 'P',
          lat: '52.22977',
          lng: '21.01178',
          name: 'Warsaw',
          fcode: 'PPLC',
          fclName: 'city, village,...',
          countryId: '798544',
          fcodeName: 'capital of a political entity',
          geonameId: 756135,
          adminCode1: '78',
          adminName1: 'Mazovia',
          population: 1702139,
          adminCodes1: {
            ISO3166_2: '14',
          },
          countryCode: 'PL',
          countryName: 'Poland',
          toponymName: 'Warsaw',
        },
        specification: '',
      },
    ],
    deathCountry: 'France',
    deathDetails:
      'at home surrounded by family, from health complications related to her age.fsddsfsdfsf sdfsfsdfsd',
    bornCountryCode: 'it',
    funDescriptions: ['Dog lover', 'Hopeless romantic', 'Mountain climber'],
    birthDateTopSong: {
      title: 'The Chipmunk Song',
      artist: 'The Chipmunks With David Seville',
      spotify: {
        uri: 'spotify:track:02NKMA9cIkq6VuBNu9q9Wf',
        url: 'https://open.spotify.com/track/02NKMA9cIkq6VuBNu9q9Wf',
      },
    },
    bornPlaceGeoJSON: {
      fcl: 'P',
      lat: '41.89193',
      lng: '12.51133',
      name: 'Rome',
      fcode: 'PPLC',
      fclName: 'city, village,...',
      countryId: '3175395',
      fcodeName: 'capital of a political entity',
      geonameId: 3169070,
      adminCode1: '07',
      adminName1: 'Latium',
      population: 2318895,
      adminCodes1: {
        ISO3166_2: '62',
      },
      countryCode: 'IT',
      countryName: 'Italy',
      toponymName: 'Rome',
    },
    deathCountryCode: 'fr',
    militaryCategory: 'Firefighter',
    deathPlaceGeoJSON: {
      fcl: 'P',
      lat: '48.85341',
      lng: '2.3488',
      name: 'Paris',
      fcode: 'PPLC',
      fclName: 'city, village,...',
      countryId: '3017382',
      fcodeName: 'capital of a political entity',
      geonameId: 2988507,
      adminCode1: '11',
      adminName1: 'Île-de-France',
      population: 2138551,
      adminCodes1: {
        ISO3166_2: 'IDF',
      },
      countryCode: 'FR',
      countryName: 'France',
      toponymName: 'Paris',
    },
    personalRelationship: 'Friend',
  },
  achievements: {
    achievements: [],
  },
  relationships: {
    photos: [
      {
        image: {
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/a84b80c7-17b2-457c-b909-5c68db5bad62.jpg',
        },
        isFav: true,
        relationshipGroup: 'Important people',
      },
      {
        image: {
          remoteUrl:
            'https://memories-backend.dev.rollstudio.it/media/photos/15c00b94-40f8-48d0-9162-8b4a8e994350.jpg',
        },
        isFav: false,
        relationshipGroup: 'Important people',
      },
    ],
    memories: [
      {
        description: 'I remember when they called her Fonda',
      },
      {
        description: 'I think the box should close afterwards.',
      },
      {
        author: 'Orlando Festa',
        description: 'Testing the email request. ',
        relationship: 'Random',
      },
    ],
    importantRelationships: [
      {
        uuid: 'c52a9d54-e743-4cdb-9ca0-d367d389669f',
        firstName: 'Jane',
        relationship: 'Friend',
        defaultPicture: 0,
        relationshipGroup: 'Friendship',
        importantRelationships: true,
      },
    ],
  },
};

export const lifelinesData = [STEVE_LIFELINE, MARILYN_LIFELINE, JANE_LIFELINE];
